/* tslint:disable */
/* eslint-disable */
/* @relayHash e2a586eb9c970573cfa986693da89bbd */

import { ConcreteRequest } from "relay-runtime";
export type mutations_UpdateCompanyMutationVariables = {
    uuid: string;
    name?: string | null;
    contactEmail?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    county?: string | null;
    postCode?: string | null;
};
export type mutations_UpdateCompanyMutationResponse = {
    readonly updateCompany: {
        readonly uuid: string;
        readonly name: string;
        readonly contactEmail: string;
        readonly address: {
            readonly addressLine1: string;
            readonly addressLine2: string;
            readonly county: string;
            readonly postCode: string;
        };
    } | null;
};
export type mutations_UpdateCompanyMutation = {
    readonly response: mutations_UpdateCompanyMutationResponse;
    readonly variables: mutations_UpdateCompanyMutationVariables;
};



/*
mutation mutations_UpdateCompanyMutation(
  $uuid: UUID!
  $name: String
  $contactEmail: String
  $addressLine1: String
  $addressLine2: String
  $county: String
  $postCode: String
) {
  updateCompany(input: {uuid: $uuid, companyName: $name, contactEmail: $contactEmail, addressLine1: $addressLine1, addressLine2: $addressLine2, county: $county, postCode: $postCode}) {
    uuid
    name
    contactEmail
    address {
      addressLine1
      addressLine2
      county
      postCode
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "uuid",
            "type": "UUID!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "name",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "contactEmail",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "addressLine1",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "addressLine2",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "county",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "postCode",
            "type": "String",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "updateCompany",
            "storageKey": null,
            "args": [
                {
                    "kind": "ObjectValue",
                    "name": "input",
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "addressLine1",
                            "variableName": "addressLine1"
                        },
                        {
                            "kind": "Variable",
                            "name": "addressLine2",
                            "variableName": "addressLine2"
                        },
                        {
                            "kind": "Variable",
                            "name": "companyName",
                            "variableName": "name"
                        },
                        {
                            "kind": "Variable",
                            "name": "contactEmail",
                            "variableName": "contactEmail"
                        },
                        {
                            "kind": "Variable",
                            "name": "county",
                            "variableName": "county"
                        },
                        {
                            "kind": "Variable",
                            "name": "postCode",
                            "variableName": "postCode"
                        },
                        {
                            "kind": "Variable",
                            "name": "uuid",
                            "variableName": "uuid"
                        }
                    ]
                }
            ],
            "concreteType": "Company",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "uuid",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "contactEmail",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "address",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Address",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "addressLine1",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "addressLine2",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "county",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "postCode",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "mutations_UpdateCompanyMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "mutations_UpdateCompanyMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "mutations_UpdateCompanyMutation",
            "id": null,
            "text": "mutation mutations_UpdateCompanyMutation(\n  $uuid: UUID!\n  $name: String\n  $contactEmail: String\n  $addressLine1: String\n  $addressLine2: String\n  $county: String\n  $postCode: String\n) {\n  updateCompany(input: {uuid: $uuid, companyName: $name, contactEmail: $contactEmail, addressLine1: $addressLine1, addressLine2: $addressLine2, county: $county, postCode: $postCode}) {\n    uuid\n    name\n    contactEmail\n    address {\n      addressLine1\n      addressLine2\n      county\n      postCode\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'f96569dab93dbe508a255c84d1977130';
export default node;
